import { Route } from "@/interfaces/Routes";

export const CONSTANTS: Route = {
  FRONTEND_URL: process.env.VUE_APP_FRONTEND_URL,
  BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
};
